import React from 'react';
import { SimulationConfig } from '@/types';
import { PhysicsSettingsSection } from './PhysicsSettingsSection';
import { AdvancedPhysicsSection } from './AdvancedPhysicsSection';
import { BallPlacementSection } from './BallPlacementSection';
import { AudioSpectrumSection } from './AudioSpectrumSection';
import { OutsideColliderSection } from './OutsideColliderSection';
import { CollapsibleSection } from './CollapsibleSection';
import { Atom, Cpu, Zap, Box, Compass, GitFork, Activity } from 'lucide-react';

interface PhysicsTabProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
  getLockInfo: (settingId: string) => any;
  onUpgradeClick: () => void;
}

export const PhysicsTab: React.FC<PhysicsTabProps> = ({ config, setConfig, getLockInfo, onUpgradeClick }) => {
  const isLocked = (id: string) => getLockInfo(id).isLocked;
  const plan = (id: string) => getLockInfo(id).min_plan;

  return (
    <div className="flex flex-col w-full pb-10">
      <PhysicsSettingsSection 
        config={config} 
        setConfig={setConfig} 
        isLocked={isLocked('physicsDynamics')}
        minPlan={plan('physicsDynamics')}
        onUpgradeClick={onUpgradeClick}
      />

      <BallPlacementSection 
        config={config} 
        setConfig={setConfig} 
        isLocked={isLocked('ballPlacement')}
        minPlan={plan('ballPlacement')}
        onUpgradeClick={onUpgradeClick}
      />

      <AdvancedPhysicsSection 
        config={config} 
        setConfig={setConfig} 
        isLocked={isLocked('physics_advanced')}
        minPlan={plan('physics_advanced')}
        onUpgradeClick={onUpgradeClick}
      />

      <CollapsibleSection
        title="Visualizer Bar"
        icon={Activity}
        darkMode={config.darkMode}
        settingKey="audioSpectrumStudio"
        isLocked={isLocked('audioSpectrumStudio')}
        lockRequiredPlan={plan('audioSpectrumStudio')}
        onUpgradeClick={onUpgradeClick}
      >
        <AudioSpectrumSection config={config} setConfig={setConfig} isLocked={isLocked('audioSpectrumStudio')} plan={plan('audioSpectrumStudio')} onUpgradeClick={onUpgradeClick} />
      </CollapsibleSection>
      
      <OutsideColliderSection 
        config={config} 
        setConfig={setConfig} 
        isLocked={isLocked('outsideCollider')}
        minPlan={plan('outsideCollider')}
        onUpgradeClick={onUpgradeClick}
      />
    </div>
  );
};
